"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SceneInromobile;

var _react = _interopRequireWildcard(require("react"));

var _FlexRelatedAuto = _interopRequireDefault(require("../FlexRelatedAuto"));

var _ArchMo = _interopRequireDefault(require("./ArchMo"));

var _utils = require("../../../utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SuccessIcon = require('@tencent/ixd-icons-react/dist').SuccessIcon;

function SceneInromobile(props) {
  var flexTitle = props.flexTitle,
      MobileImage = props.MobileImage,
      handleClickPic = props.handleClickPic,
      firstTitle = props.firstTitle,
      secondTitle = props.secondTitle,
      thirdTitle = props.thirdTitle,
      secondList = props.secondList,
      onepartDesc = props.onepartDesc,
      clickPicTxt = props.clickPicTxt,
      thirdList = props.thirdList,
      clickPicTxtColor = props.clickPicTxtColor,
      backgroundThirdImage = props.backgroundThirdImage,
      backgroundUrl = props.backgroundUrl;

  var _a = (0, _utils.fomateFileData)(MobileImage),
      mobileImage = _a.url,
      _b = _a.alt,
      alt = _b === void 0 ? '' : _b;

  var _c = (0, _react.useState)(false),
      isShow = _c[0],
      setIsShow = _c[1];

  var handleShowPic = function handleShowPic() {
    setIsShow(!isShow);
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'aduio-video-sceneintroduce-container-mo',
    style: backgroundUrl ? {
      background: "url(" + backgroundUrl + ") center no-repeat ",
      backgroundSize: 'cover'
    } : {}
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: 'aduio-video-sceneintroduce-big-title-mo'
  }, flexTitle), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'aduio-video-sceneintroduce-onepart-mo'
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: 'aduio-video-sceneintroduce-small-title-mo'
  }, firstTitle), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'aduio-video-sceneintroduce-imgwrap-mo'
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: 'aduio-video-sceneintroduce-big-img-mo',
    src: mobileImage || 'https://test-staticintl.cloudcachetci.com/cms/backend-cms/KRGV469_m01.png',
    alt: alt
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'onepart-desc-mo'
  }, onepartDesc), clickPicTxt && /*#__PURE__*/_react["default"].createElement("div", {
    className: 'onepart-href-mo'
  }, /*#__PURE__*/_react["default"].createElement("span", {
    onClick: handleShowPic,
    style: {
      color: clickPicTxtColor
    }
  }, clickPicTxt))), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'aduio-video-sceneintroduce-secondpar-mo'
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: 'secondpart-title'
  }, secondTitle), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'secondpart-desc'
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: 'secondpart-desc-ul'
  }, secondList === null || secondList === void 0 ? void 0 : secondList.map(function (item, index) {
    var txt = (item || {}).txt;
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: index,
      className: 'secondpart-desc-li'
    }, /*#__PURE__*/_react["default"].createElement(SuccessIcon, {
      style: {
        color: clickPicTxtColor
      }
    }), txt);
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'aduio-video-sceneintroduce-thirdpart-mo'
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: 'thirdpart-title'
  }, thirdTitle), /*#__PURE__*/_react["default"].createElement(_FlexRelatedAuto["default"], {
    thirdList: thirdList,
    backgroundThirdImage: backgroundThirdImage
  }))), isShow ? /*#__PURE__*/_react["default"].createElement(_ArchMo["default"], {
    handleClickPic: handleClickPic,
    handleisShow: function handleisShow(data) {
      setIsShow(data);
    }
  }) : null);
}